<!-- Loading overlay -->
<div *ngIf="isLoading" class="loading-overlay">
  <mat-spinner diameter="50"></mat-spinner>
</div>

<div
  class="dashboard-filter-container"
  [formGroup]="dashboardForm"
  *ngIf="dashboardForm && !isLoading"
>
  <mat-form-field>
    <mat-label>Date range</mat-label>

    <span matPrefix (click)="openDatePicker()">
      <img
        src="/assets/images/icons-kpi-dashboard/shooting-schedule.png"
        alt="Date Icon"
        class="date-icon"
      />
    </span>

    <mat-date-range-input
      [rangePicker]="dashboardpicker"
      [min]="minDate"
      [max]="maxDate"
      (click)="openDatePicker()"
    >
      <input matStartDate formControlName="startDate" aria-label="Start Date" />
      <input
        aria-label="End Date"
        matEndDate
        formControlName="endDate"
        (dateChange)="onDateRangeChange()"
        readonly
        (keydown)="$event.preventDefault()"
        (paste)="$event.preventDefault()"
      />
    </mat-date-range-input>
    <mat-date-range-picker #dashboardpicker></mat-date-range-picker>
  </mat-form-field>

  <mat-form-field *ngIf="showServiceType">
    <mat-label>Service Type</mat-label>
    <span matPrefix>
      <img
        src="../../../assets/images/icons-kpi-dashboard/customer-service.png"
        alt="Service Icon"
        class="furniture-icon"
      />
    </span>

    <mat-select
      formControlName="category"
      multiple
      (selectionChange)="onCategorySelectionChange($event)"
      [compareWith]="compareCategories"
      class="category-selection"
    >
      <mat-option *ngFor="let category of categories" [value]="category.id">
        {{ category.name }}
      </mat-option>
    </mat-select>
  </mat-form-field>
</div>

<!-- <div class="container" *ngIf="dashboardForm" [ngClass]="companyId === 4 ? 'card-container-company' : 'card-container'"> -->
<!-- {{mappedCategories | json}} -->
<div class="container card-container" *ngIf="dashboardForm">
  <div *ngFor="let category of mappedCategories" class="skill-card card">
    <mat-card class="card">
      <!-- Card Header -->
      <header
        class="skill-card__header"
        [ngClass]="{ highlight: category['name'] === 'Delivery Days' }"
      >
        <mat-card-subtitle
          *ngIf="category['name'] === 'Delivery Days'"
          matTooltip="This metric describes the difference between the customer preferred execution date and actual execution date. When an earlier than initially preferred execution date is achieved, this metric will become negative."
          matTooltipHideDelay="10000"
        >
          {{ category["name"] }}
        </mat-card-subtitle>
        <mat-card-subtitle *ngIf="category['name'] !== 'Delivery Days'">
          {{ category["name"] }}
        </mat-card-subtitle>
      </header>

      <!-- Card Content -->
      <section class="skill-card__body">
        <div
          id="star-rating"
          [ngClass]="{
            'star-rating': category['name'] === 'Avg. Rating',
            'no-stars': category['name'] !== 'Avg. Rating',
          }"
        >
          <!-- Specific Content for 'Lead fee', 'Avg. Invoice', and 'Total Invoice' -->
          <ng-container
            *ngIf="
              category['name'] === 'Lead fee (incl. VAT)' ||
                category['name'] === 'Avg. Invoice (incl. VAT)' ||
                category['name'] === 'Total invoice (incl. VAT)';
              else defaultContent
            "
          >
            <!-- Hide 'Avg. Invoice' and 'Total invoice' cards if companyId is 4 -->
            <p>
              &#8364;
              {{ category["value"] | currency: "EUR" : "" : "1.2-2" : "de" }}
            </p>
          </ng-container>

          <!-- Check if the category name is 'Avg. Rating' -->
          <ng-container *ngIf="category['name'] === 'Avg. Rating'">
            <!-- Display star rating and message if available -->
            <div class="star-rating" [innerHTML]="category['value']"></div>
          </ng-container>

          <!-- Default Content -->
          <ng-template #defaultContent>
            <p *ngIf="category['name'] !== 'Avg. Rating'">
              {{ category["value"] }}
            </p>
          </ng-template>
        </div>
      </section>
    </mat-card>
  </div>
</div>

<!-- Charts Section -->
<div class="chart-container" *ngIf="dashboardForm">
  <mat-card>
    <mat-card-header class="card-heading">
      <div>
        <mat-card-subtitle>Lead Fees </mat-card-subtitle>
      </div>
      <div>
        <mat-icon (click)="zoomGraph(1)"> zoom_out_map</mat-icon>
      </div>
    </mat-card-header>
    <mat-card-content>
      <app-bar-chart
        [startDate]="dashboardForm.controls['startDate'].value"
        [endDate]="dashboardForm.controls['endDate'].value"
        [categoryIds]="categoryIds"
        [companyId]="companyId"
      ></app-bar-chart>
    </mat-card-content>
  </mat-card>

  <mat-card class="card">
    <mat-card-header class="card-heading">
      <div>
        <mat-card-subtitle>Bookings</mat-card-subtitle>
      </div>
      <div>
        <mat-icon (click)="zoomGraph(2)"> zoom_out_map</mat-icon>
      </div>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="companyId !== 20">
        <app-line-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
          apiType='line'
        ></app-line-chart>
      </ng-container>

      <ng-container *ngIf="companyId === 20">
        <app-stacked-bar-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
          apiType="stack"
        ></app-stacked-bar-chart>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

<div class="chart-container" *ngIf="dashboardForm && companyId === 1">
  <mat-card class="card">
    <mat-card-header class="card-heading">
      <div>
        <mat-card-subtitle>Bookings per store</mat-card-subtitle>
      </div>
      <div><mat-icon (click)="zoomGraph(3)"> zoom_out_map</mat-icon></div>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="companyId === 1">
        <app-stacked-bar-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
          apiType="store"
        ></app-stacked-bar-chart>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <mat-card class="card booking-percentage-card">
    <mat-card-header class="card-heading">
      <div>
        <mat-card-subtitle>Bookings per store (Ytd)</mat-card-subtitle>
      </div>
      <div>
        <mat-icon (click)="zoomGraph(4)"> zoom_out_map</mat-icon>
      </div>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="companyId === 1">
        <app-pie-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
        ></app-pie-chart>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>

<!-- for leenbakker -->
<div
  class="chart-container d-flex flex-row"
  *ngIf="dashboardForm && companyId === 20"
>
  <mat-card class="card">
    <mat-card-header class="card-heading">
      <div>
        <mat-card-subtitle>Bookings per store</mat-card-subtitle>
      </div>
      <div><mat-icon (click)="zoomGraph(3)"> zoom_out_map</mat-icon></div>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="companyId === 20">
        <app-single-bar-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
          apiType="count"
        ></app-single-bar-chart>
      </ng-container>
    </mat-card-content>
  </mat-card>

  <mat-card class="card booking-percentage-card">
    <mat-card-header class="card-heading">
      <div>
        @if(companyId === 20) {
          <mat-card-subtitle>Bookings MODULE vs. API</mat-card-subtitle>
        } @else {
          <mat-card-subtitle>Bookings per store (Ytd)</mat-card-subtitle>
        }
      </div>
      <div>
        <mat-icon (click)="zoomGraph(4)"> zoom_out_map</mat-icon>
      </div>
    </mat-card-header>
    <mat-card-content>
      <ng-container *ngIf="companyId === 20">
        <app-line-chart
          [startDate]="dashboardForm.controls['startDate'].value"
          [endDate]="dashboardForm.controls['endDate'].value"
          [categoryIds]="categoryIds"
          [companyId]="companyId"
          apiType='bookingPercent'
        ></app-line-chart>
      </ng-container>
    </mat-card-content>
  </mat-card>
</div>
